import React, { Component } from 'react'
import { observer } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import Paragraph from '@components/Details/Paragraph'
import Attachment, { confirmDelete } from '@components/Attachment'
import InfoPanel from './InfoPanel'
import Actions from './Actions'
import PropTypes from 'prop-types'

class Details extends Component {
  render () {
    const { contractStore } = this.props
    const { contract } = contractStore

    return (
      <DocumentTitle
        title={`${contract.contractReference} - details | Atheneum Partners`}
      >
        <div className='details-wrapper'>
          <Actions contractStore={contractStore} />
          <InfoPanel contractStore={contractStore} />
          <div className='main-section-wrapper'>
            <h2>Invoicing instructions</h2>
            <Paragraph value={contract.invoicingInstructions} />
            <h2>Special conditions</h2>
            <Paragraph value={contract.specialConditions} />
            <h2>Additional comments</h2>
            <Paragraph value={contract.additionalComment} />
            <Attachment
              label='Attachments'
              attachments={contract.attachments}
              url={`/api/contract/${contract.id}/attachments`}
              onOk={() => {
                contractStore.getAttachments(contract.id)
              }}
              onDelete={fileId =>
                confirmDelete(fileId, contractStore.deleteAttachment)
              }
            />
          </div>
        </div>
      </DocumentTitle>
    )
  }

  static propTypes = {
    contractStore: PropTypes.object
  }
}

export default observer(Details)
